<div class="search-results-container">
    <div class="results-header">
        <h4 *ngIf="!loading" class="results-count">
            Results ( {{ pagination.total }} )
            <span *ngIf="pagination.pageCount > 1" class="pagination-info">
                - Page {{ pagination.page }} of {{ pagination.pageCount }}
            </span>
        </h4>

        <div class="escape-container" (click)="handleSearchClose()">
            <span class="desktop-search-close">Press <u>esc</u> to close this window</span>
            <span class="material-symbols-rounded close-btn">close</span>
        </div>
    </div>

    <div *ngIf="loading" class="loading-container">
        <img src="./assets/icons/loading.gif" alt="Loading">
    </div>

    <ul class="results-list" *ngIf="results && results.length > 0">
        <!-- API Result Card -->
        <li class="result-card" *ngFor="let result of results" (click)="handleSearchClose()">
            
            <!-- API Results (Endpoint, Parameter, Response, Response Property) -->
            <ng-container *ngIf="isApiResult(result)">
                <ul class="breadcrumb">
                    <li>
                        <a routerLink="/e/{{ result.endpointPath }}">
                            <span [innerHTML]="result.resultType"></span>
                        </a>
                    </li>
                    <li *ngIf="result.group">
                        <a routerLink="/e/{{ result.endpointPath }}" [innerHTML]="result.group"></a>
                    </li>
                    
                    <li class="active" *ngIf="result.resultType == 'Endpoint'">
                        <a routerLink="/e/{{ result.endpointPath }}" [innerHTML]="result.endpointHL"></a>
                    </li>
                    <li class="active" *ngIf="result.resultType == 'Parameter' || result.resultType == 'Response' || result.resultType == 'Response Property'">
                        <a routerLink="/e/{{ result.endpointPath }}" [queryParams]="{fragment:result.slug}" [innerHTML]="result.endpointHL"></a>
                    </li>
                    <li *ngIf="result.parentHasParent">...</li>
                    <li class="active" *ngIf="(result.resultType == 'Parameter' || result.resultType == 'Response Property') && result.parent">
                        <a routerLink="/e/{{ result.endpointPath }}" [queryParams]="{fragment:result.parentSlug}" [innerHTML]="result.parentHL"></a>
                    </li>
                    <!-- <li class="active" *ngIf="result.resultType == 'Parameter'"><a routerLink="/e/{{ result.endpointPath }}"
                            [queryParams]="{fragment:result.slug}" [innerHTML]="result.paramNameHL"></a></li> -->
                </ul>
                <a routerLink="/e/{{ result.endpointPath }}" [queryParams]="{fragment:result.slug}"
                    class="result-box-anchor">
                    <div class="result-top" *ngIf="result.paramName">
                        <span class="request-method post" *ngIf="result.method">{{ result.method }}</span>
                        <div class="name" *ngIf="result.paramName" [innerHTML]="result.paramName"></div>
                        <span class="data-type" *ngIf="result.type">{{ result.type }}</span>
                    </div>
                    <div class="result-path name" [innerHTML]="result.uri"></div>
                    <div class="result-code" *ngIf="result.code" [innerHTML]="result.code"></div>
                    <div class="result-code-label" *ngIf="result.code" [innerHTML]="result.label"></div>
                    <div class="result-blurb" [innerHTML]="result.description"></div>
                </a>
            </ng-container>

            <!-- Docs Page Results -->
            <ng-container *ngIf="isDocsResult(result)">
                <ul class="breadcrumb">
                    <li>
                        <a routerLink="/docs">
                            <span [innerHTML]="result.resultType"></span>
                        </a>
                    </li>
                    <li *ngIf="result.category">
                        <a routerLink="/docs/{{ result.slug }}" [innerHTML]="result.category"></a>
                    </li>
                    <li class="active">
                        <a routerLink="/docs/{{ result.slug }}" [innerHTML]="result.label"></a>
                    </li>
                </ul>
                <a routerLink="/docs/{{ result.slug }}" class="result-box-anchor">
                    <div class="result-top">
                        <div class="name" [innerHTML]="result.label"></div>
                    </div>
                    <div class="result-blurb" [innerHTML]="result.description"></div>
                </a>
            </ng-container>
        </li>
    </ul>

    <!-- Pagination Controls -->
    <div class="pagination-container" [ngClass]="{'disabled': loading}" *ngIf="pagination.total > 0 && pagination.pageCount > 1">
        <div class="pagination-choices" aria-label="Page navigation">
            <a *ngIf="pagination.page !== 1 && pagination.page !== 2" 
            [ngClass]="{ disabled: pagination.page === 1 }" 
            (click)="goToPage(1)" 
            tabindex="0" 
            (keydown.enter)="goToPage(1)" 
            class="pagination-arrow" 
            aria-label="First">
                <span class="material-symbols-rounded">first_page</span>
            </a>
            <a [ngClass]="{ disabled: pagination.page === 1 }" 
            (click)="prevPage()"  
            tabindex="0" 
            (keydown.enter)="prevPage()" 
            class="pagination-arrow" 
            aria-label="Previous">
                <span class="material-symbols-rounded">chevron_left</span>
            </a>
            <a *ngFor="let page of visiblePages" 
            [ngClass]="{ 'active': pagination.page === page, 'disabled': pagination.page === page }" 
            (click)="goToPage(page)"  
            tabindex="0" 
            (keydown.enter)="goToPage(page)">
                {{ page }}
            </a>
            <a class="pagination-arrow"  
            [ngClass]="{ disabled: pagination.page === pagination.pageCount }"
            (click)="nextPage()" 
            tabindex="0" 
            (keydown.enter)="nextPage()" 
            aria-label="Next">
                <span class="material-symbols-rounded">chevron_right</span>
            </a>
            <a class="pagination-arrow" 
            *ngIf="pagination.page !== pagination.pageCount && pagination.page !== pagination.pageCount - 1"
            [ngClass]="{ disabled: pagination.page === pagination.pageCount }" 
            (click)="goToPage(pagination.pageCount)" 
            tabindex="0"
            (keydown.enter)="goToPage(pagination.pageCount)"
            aria-label="Last">
                <span class="material-symbols-rounded">last_page</span>
            </a>
        </div>
        <div class="pagination-size-container">
            <span class="pagination-size-label">Items per Page:</span>
            <div class="select-wrapper">
                <select [(ngModel)]="selectedPageSize" 
                        (change)="onPageSizeChange()" 
                        name="pageSize" 
                        class="per-page">
                    <option *ngFor="let size of pageSizeOptions" [ngValue]="size">
                        {{ size }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div *ngIf="results && results.length == 0 && !loading">
        <div class="result-top">
            Sorry, no results were found. Please adjust your search term and try again.
        </div>
    </div>
</div>